// Filename: TextFieldStyles.ts
//
// Component: TextField Styles
//
// Purpose:
// Provide reusable sx style objects for the TextField component.
// This keeps styling separate from logic and makes UI consistent.
//
// What this file does:
// - Uses MUI's `useTheme()` hook to access theme variables.
// - Returns style objects typed with `SxProps<Theme>` for safety.

import { makeStyles } from "tss-react/mui";

export const useTextFieldStyles = makeStyles()((theme) => ({
  default: {
    width: "100%",
  },
}));